exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".run-inputs[data-v-7e30bf02] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.run-inputs > div[data-v-7e30bf02] {\n    width: 45%;\n    margin-right: 10px;\n}\n", ""]);

// exports
